module.exports = __webpack_public_path__ + "media/images/map/map2-7cd2a5c045412a583362c8a5931d5384.png";